
















































































































































































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { BPCTable, BPCTableField } from '@shared/interfaces/bpc-table-interface';
import {
  TaxCertificate,
  taxCertificatePermissionName,
} from '@tax-certificates/interfaces/tax-certificate';
import { TaxCertificateFilters } from '@tax-certificates/interfaces/tax-certificate-filters';
import PaginationInterface from '@core/interfaces/pagination-interface';
import OrderingInterface from '@core/interfaces/ordering-interface';
import TableWrapper from '@shared/layouts/wrappers/table/table-wrapper.vue';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import SearchInput from '@shared/components/forms/inputs/search-input.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import Table from '@shared/components/tables/table.vue';
import DisplayContactLink from '@shared/components/displays/display-contact-link/display-contact-link.vue';
import { isNull } from 'lodash';
import DisplayFieldCode from '@shared/components/displays/display-field-code/display-field-code.vue';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import TaxCertificateForm from '@tax-certificates/components/tax-certificate-form.vue';
import { TaxCertificateForm as FormModel } from '@tax-certificates/interfaces/tax-certificate-form';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import { mixins } from 'vue-class-component';
import DownloadPdfUsingTemplateMixin from '@shared/components/tables/abstract-table/download-pdf-using-template-mixing';
import { FilterObject } from '@shared/interfaces/config';
import TableExportsToCSV from '@shared/components/tables/abstract-table/table-exports-to-csv';
import DisplayFieldDate from '@shared/components/displays/display-field-date/display-field-date.vue';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFiltersMixin from '@shared/components/tables/abstract-table/extended-filters-mixin';

const defaultTableFields: BPCTableField[] = [
  {
    key: 'code',
    headerLabel: `global.tax_certificates_code_header`,
    order: 0,
  },
  {
    key: 'beneficiary_fullname',
    headerLabel: `global.tax_certificates_beneficiary_fullname_header`,
    order: 1,
  },
  {
    key: 'contact_fullname',
    headerLabel: `global.tax_certificates_contact_fullname_header`,
    order: 2,
  },
  {
    key: 'period_start_date',
    headerLabel: `global.tax_certificates_start_date_label`,
    order: 3,
  },
  {
    key: 'period_end_date',
    headerLabel: `global.tax_certificates_end_date_label`,
    order: 4,
  },
  {
    key: 'attendance_days',
    headerLabel: `global.tax_certificates_num_days_label`,
    order: 5,
  },
  {
    key: 'product_paid_amount',
    headerLabel: `global.tax_certificates_paid_amount_label`,
    order: 6,
  },
];

@Component({
  name: 'bc-tax-certificate-list',
  components: {
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-drawer-modal': DrawerModal,
    'bpc-entity-select': EntitySelect,
    'bpc-search-input': SearchInput,
    'bpc-content-wrapper': ContentWrapper,
    'bpc-table-wrapper': TableWrapper,
    'bpc-table': Table,
    'bpc-display-contact-link': DisplayContactLink,
    'bpc-display-code': DisplayFieldCode,
    'bc-tax-certificate-form': TaxCertificateForm,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-display-date': DisplayFieldDate,
    'bpc-custom-filter-selector': CustomFilterSelector,
  },
})
export default class TaxCertificateList
  extends mixins(Vue, TableExportsToCSV, DownloadPdfUsingTemplateMixin, ExtendedFiltersMixin)
  implements BPCTable {
  declare $refs: TableExportsToCSV['$refs'] &
    ExtendedFiltersMixin['$refs'] & {
      taxCertificateForm: InstanceType<typeof TaxCertificateForm> & {
        saveEntity(): void;
      };
      softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
      bulkSolfDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
        onOpenModal(id): void;
        onCloseModal(): void;
      };
    };
  // PROPS
  @Prop({ type: String, default: 'table' }) readonly storeName: string;
  @Prop({ type: String, default: 'extended' }) readonly extendedFilterConfigName: string;
  @Prop(String) readonly configFileName: string;
  @Prop({ type: String }) readonly actionsPortalTarget: string;
  @Prop({ type: Boolean, default: false }) readonly disabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly isInput: boolean;
  @Prop({ type: Boolean, default: true }) readonly showFilters: boolean;
  @Prop({ type: Boolean, default: true }) readonly showOrdering: boolean;
  @Prop(Object) readonly externalFormModel: object;
  @Prop({ type: Boolean, default: true }) readonly withUrlParams: boolean;
  @Prop({ type: String }) readonly orderBy: string;
  @Prop({ type: String }) readonly orderDirection: string;
  @Prop({ type: Object }) readonly initialFilters: TaxCertificateFilters;
  @Prop({
    default() {
      return defaultTableFields;
    },
  })
  readonly tableFields: BPCTableField[];

  // DATA
  entityName: string = 'tax_certificate';
  loading: boolean = false;
  isSavingForm: boolean = false;
  showTaxCertificateForm: boolean = false;
  showExtendedFilterSection = false;
  extendedFilterKey: number = 0;
  taxCertificateFormModel: FormModel = {
    id: null,
    code: null,
    center_id: this.tenantId,
    beneficiary_firstname: null,
    beneficiary_lastname: null,
    beneficiary_birthdate: null,
    beneficiary_national_number: null,
    beneficiary_street: null,
    beneficiary_street2: null,
    beneficiary_zip: null,
    beneficiary_city: null,
    beneficiary_country: null,
    contact_id: null,
    contact_firstname: null,
    contact_lastname: null,
    contact_birthdate: null,
    contact_national_number: null,
    contact_street: null,
    contact_street2: null,
    contact_zip: null,
    contact_city: null,
    contact_country: null,
    tax_certificate_periods: [
      {
        id: null,
        center_id: this.tenantId,
        tax_certificate_id: null,
        enrollment_id: null,
        start_date: null,
        end_date: null,
        num_days: null,
        price_per_day: null,
        paid_amount: null,
      },
    ],
  };
  taxCertificates: TaxCertificate[] = [];
  filters: Partial<TaxCertificateFilters> = {
    search: null,
    contact_id: null,
    period_start_date_from: null,
    period_start_date_to: null,
    period_end_date_from: null,
    period_end_date_to: null,
  };
  checkedAllEntities: boolean = false;
  // pagination
  pageOptions: number[] = [5, 10, 15, 20, 50, 100, 200];
  pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    from: 0,
    to: 0,
    total: 0,
  };
  ordering: OrderingInterface = {
    order_by: 'code',
    order_direction: 'asc',
  };
  orderByOptions: object[] = [
    {
      text: this.$t('global.tax_certificate.ordering.code.label'),
      value: 'code',
    },
    {
      text: this.$t('global.tax_certificate.ordering.beneficiary_firstname.label'),
      value: 'beneficiary_firstname',
    },
  ];
  templateSelectorCustomFilters: FilterObject[] = [];

  // COMPUTED
  get tenantId() {
    return this.$store.getters['tenant/selectedTenantId'];
  }

  get tenantType(): string {
    return this.$store.getters['centerSettings/centerSettings']['center_type'] || 'center';
  }

  get permissionEntityName(): string {
    return taxCertificatePermissionName;
  }

  get showDownloadTaxCertificateRowAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(this.permissionEntityName, 'show')
    );
  }

  get showCreateTaxCertificatePageAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(this.permissionEntityName, 'store')
    );
  }

  get showEditTaxCertificateRowAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(this.permissionEntityName, 'update')
    );
  }
  get showDeleteTaxCertificateRowAction(): boolean {
    return (
      !this.disabled &&
      this.$authorizationService.hasPermissionForAction(this.permissionEntityName, 'delete')
    );
  }

  get hideInputLabel(): object {
    return {
      labelAttributes: {
        for: 'input',
      },
    };
  }

  get fieldsToShow(): object[] {
    return this.tableFields.sort((f1, f2) => f1.order - f2.order);
  }

  get taxCertificateId() {
    return this.taxCertificateFormModel?.id;
  }

  get formModalTitle() {
    if (this.taxCertificateId) {
      return this.$t('global.modals.edit_tax_certificate_title');
    } else {
      return this.$t('global.modals.create_tax_certificate_title');
    }
  }

  get displayCodeConfig(): object {
    return {
      displayType: 'code',
      key: 'code',
    };
  }

  get displayContactConfig(): object {
    return {
      displayType: 'contact-link',
      useDrawer: true,
      formConfigName: 'edit',
      drawerSize: 'lg',
      configFileName: this.tenantType === 'center' ? 'contact' : 'contact_for_club',
    };
  }

  get displayPeriodStartDateConfig(): object {
    return {
      displayType: 'date',
      key: 'period_start_date',
    };
  }

  get displayPeriodEndDateConfig(): object {
    return {
      displayType: 'date',
      key: 'period_end_date',
    };
  }

  get changeDetectorStr(): string {
    return [
      this.pagination.per_page,
      this.pagination.current_page,
      this.ordering.order_by,
      this.ordering.order_direction,
      this.filters.search,
      this.filters.contact_id,
      this.filters.period_start_date_from,
      this.filters.period_start_date_to,
      this.filters.period_end_date_from,
      this.filters.period_end_date_to,
    ].join('--');
  }

  get softDeleteConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'tax-certificate-soft-delete-modal',
      title: this.$t('global.modals.tax_certificate_soft_delete_title') as string,
      body: this.$t('global.modals.tax_certificate_soft_delete_body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.move_to_trash') as string,
      acceptButtonVariant: 'danger',
    };
  }

  get selection(): number[] {
    return this.checkedItems.map(item => item.id);
  }

  get selectionCount(): number {
    return (this.checkedItems || []).length;
  }

  get checkedItems() {
    return this.taxCertificates?.filter(item => item.checked);
  }

  // METHODS
  resetTaxCertificateFormModel() {
    this.taxCertificateFormModel = {
      id: null,
      code: null,
      center_id: this.tenantId,
      beneficiary_firstname: null,
      beneficiary_lastname: null,
      beneficiary_birthdate: null,
      beneficiary_national_number: null,
      beneficiary_street: null,
      beneficiary_street2: null,
      beneficiary_zip: null,
      beneficiary_city: null,
      beneficiary_country: null,
      contact_id: null,
      contact_firstname: null,
      contact_lastname: null,
      contact_birthdate: null,
      contact_national_number: null,
      contact_street: null,
      contact_street2: null,
      contact_zip: null,
      contact_city: null,
      contact_country: null,
      tax_certificate_periods: [
        {
          id: null,
          center_id: this.tenantId,
          tax_certificate_id: null,
          enrollment_id: null,
          start_date: null,
          end_date: null,
          num_days: null,
          price_per_day: null,
          paid_amount: null,
        },
      ],
    };
  }

  clickOnCreate() {
    this.showTaxCertificateForm = true;
  }
  clickOnEdit(item: Partial<TaxCertificate>) {
    console.log(item);
    this.taxCertificateFormModel.id = item.id;
    this.showTaxCertificateForm = true;
  }

  clickOnDownload(item: Partial<TaxCertificate>) {
    this.onDownloadPdfUsingTemplate(item);
  }

  clickOnCloseForm() {
    this.showTaxCertificateForm = false;
    this.isSavingForm = false;
    this.resetTaxCertificateFormModel();
  }

  clickOnSaveForm() {
    this.isSavingForm = true;
    this.$refs.taxCertificateForm.saveEntity();
  }

  onSavedForm() {
    this.getTaxCertificatesIfStopChanging();
    this.clickOnCloseForm();
  }

  onErrorSavingForm() {
    this.isSavingForm = false;
  }

  clickOnDelete(item: TaxCertificate) {
    this.$refs.softDeleteConfirmationModal.onOpenModal(item.id);
  }
  clickOnReload() {
    this.getTaxCertificatesIfStopChanging();
  }
  clickOnChangeOrderDirection(direction: string) {
    this.ordering.order_direction = direction;
  }
  onCheckAll(val: boolean) {
    this.checkedAllEntities = val;
  }
  getQueryParams() {
    return {
      order_by: this.ordering.order_by,
      order_direction: this.ordering.order_direction,
      per_page: this.pagination.per_page,
      page: this.pagination.current_page,
      search: this.filters.search,
      contact_id: this.filters.contact_id,
      period_start_date_from: this.filters.period_start_date_from,
      period_start_date_to: this.filters.period_start_date_to,
      period_end_date_from: this.filters.period_end_date_from,
      period_end_date_to: this.filters.period_end_date_to,
    };
  }
  getUrlParams() {
    const urlQueryParams = JSON.parse(JSON.stringify(this.$route.query), (k, v) => {
      if (!isNaN(v) && !isNull(v)) {
        return parseInt(v);
      }
      return v;
    });
    return {
      ...urlQueryParams,
    };
  }
  setUrlParams(params) {
    if (this.withUrlParams) {
      this.$router.push({ query: params }).catch(e => {
        return null;
      });
    }
  }
  initializeFiltersFromProperties() {
    if (this.initialFilters) {
      this.filters = { ...this.filters, ...this.initialFilters };
    }
  }
  initializeOrderingFromProperties() {
    if (this.orderBy) {
      this.ordering.order_by = this.orderBy;
    }

    if (this.orderDirection) {
      this.ordering.order_direction = this.orderDirection;
    }
  }
  initializeValuesFromUrlParams() {
    if (this.withUrlParams) {
      const urlParams = this.getUrlParams();
      if (!this.filters?.search) {
        this.filters.search = urlParams?.search || '';
      }
      if (!this.filters.contact_id) {
        this.filters.contact_id = urlParams?.contact_id || null;
      }
      if (!this.filters.period_start_date_from) {
        this.filters.period_start_date_from = urlParams?.period_start_date_from || null;
      }
      if (!this.filters.period_start_date_to) {
        this.filters.period_start_date_to = urlParams?.period_start_date_to || null;
      }
      if (!this.filters.period_end_date_from) {
        this.filters.period_end_date_from = urlParams?.period_end_date_from || null;
      }
      if (!this.filters.period_end_date_to) {
        this.filters.period_end_date_to = urlParams?.period_end_date_to || null;
      }
      if (!this.orderBy) {
        this.ordering.order_by = urlParams?.order_by || 'code';
      }
      if (!this.orderDirection) {
        this.ordering.order_direction = urlParams?.order_direction || 'desc';
      }
      if (urlParams?.per_page) {
        this.pagination.per_page = urlParams?.per_page || 15;
      }
    }
  }
  async getTaxCertificates() {
    this.loading = true;
    this.checkedAllEntities = false;
    const params = this.getQueryParams();
    const url = this.$bpcApiRouteHelper.getEntityPath('tax-certificate');
    const res = await this.$bpcApi.get(url, { params: params }).toPromise();
    this.taxCertificates = res.data;
    this.pagination = res.meta;
    this.setUrlParams(params);
    this.loading = false;
  }
  getTaxCertificatesIfStopChanging() {
    const changeStr = this.changeDetectorStr;
    setTimeout(() => {
      if (changeStr === this.changeDetectorStr) {
        this.getTaxCertificates();
      }
    }, 300);
  }

  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.getTaxCertificatesIfStopChanging();
  }
  onSuccessBulkSoftDelete() {
    this.$refs.bulkSolfDeleteConfirmationModal.onCloseModal();
    this.getTaxCertificatesIfStopChanging();
  }

  async onDownloadPdfUsingTemplate(item) {
    this.downloadPdfUsingTemplateSelectedItemIds = item?.id ? [item?.id] : [];
    this.templateSelectorCustomFilters = [
      {
        filterField: 'status',
        value: 'active',
      },
    ];
    this.downloadPdfUsingTemplateCleanErrors();
    this.openDownloadPdfUsingTemplateModal();
  }
  async closeDownloadPdfUsingTemplateModal() {
    this.isDownloadingPdfUsingTemplate = false;
    this.showDownloadPdfUsingTemplateModal = false;
    this.templateSelectorCustomFilters = [];
    this.downloadPdfUsingTemplateCleanErrors();
  }

  onChangeFilter() {
    this.filters = { ...this.filters, ...this.$refs.extendedFilter.filterModel };
  }

  onChangeContactFilter() {
    const filterModel = this.$refs.extendedFilter.filterModel
      ? { ...this.$refs.extendedFilter.filterModel, contact_id: this.filters.contact_id }
      : { ...this.filters };
    this.$store.commit(`${this.storeName}/setFilterModel`, {
      entity: this.entityName,
      model: filterModel,
    });
    this.extendedFilterKey++;
  }

  onExtendedFilterFormSearch(model = null) {
    const filterModel = model ? model : this.$refs.extendedFilter.filterModel;
    this.$store.commit(`${this.storeName}/setFilterModel`, {
      entity: this.entityName,
      model: filterModel,
    });

    // Set in the local filters to make reactive and trigger the watcher
    this.filters = { ...this.filters, ...filterModel };

    if (this.isInput) {
      this.onExtendedFilterFormClose();
    }
  }

  // WATCHERS
  @Watch('changeDetectorStr')
  onChangeDetectorStrChange(val: string) {
    if (val) {
      this.getTaxCertificatesIfStopChanging();
    }
  }

  // LIFECYCLE
  mounted() {
    this.initializeFiltersFromProperties();
    this.initializeOrderingFromProperties();
    this.initializeValuesFromUrlParams();
    // Set the filters in the store for the extended filters
    this.$store.commit(`${this.storeName}/setFilterModel`, {
      entity: this.entityName,
      model: this.filters,
    });
    this.getTaxCertificatesIfStopChanging();
  }
}
